import { DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { Trans } from "react-i18next";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { ContractModel } from "../Contract.types.ts";
import { useContractResponsibilityHelper } from "../ContractResponsibilityHelper.hooks.ts";
import GroupCompaniesField from "../../../entityTemplates/fields/GroupCompaniesField.tsx";

export interface ContractGroupCompaniesAccessFieldProps {
    contract: ContractModel | undefined;
    isLoading: boolean;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    addGroupEntityDialogHeader: string;
    disableAccessWarning?: boolean;
}

function ContractGroupCompaniesAccessField(props: ContractGroupCompaniesAccessFieldProps) {
    const { translateString } = useTranslation();
    const { onFieldChange, handleDialogConfirm, pendingUserChanges, setPendingUserChanges } = useContractResponsibilityHelper(
        props.onChange,
        props.disableAccessWarning
    );

    return (
        <>
            <GroupCompaniesField
                groupEntities={props.contract?.groupEntities ?? []}
                isLoading={props.isLoading}
                addGroupEntityDialogHeader={props.addGroupEntityDialogHeader}
                onChange={({ groupEntities, allGroupEntityAccess }) => {
                    const newContract = { ...props.contract!, groupEntities, allGroupEntityAccess };
                    onFieldChange(newContract, props.contract!);
                }}
                readOnly={props.readOnly}
                disabled={props.disabled}
                isPreview={props.isPreview}
                errorText={props.errorText}
                allGroupEntityAccess={props.contract?.allGroupEntityAccess ?? true}
                requireSelectionBeforeUncheck={!props.disableAccessWarning}
            />

            {pendingUserChanges && (
                <DotLegalDeleteDialog
                    open
                    headerText={translateString("confirmAccessRemoval")}
                    alertBodyText={
                        <Trans
                            i18nKey="confirmContractAccessRemovalBody"
                            components={{
                                ul: <ul />,
                                li: <li />,
                            }}
                        />
                    }
                    warningTranslation={translateString("warning")}
                    deleteBtnText={translateString("save")}
                    cancelBtnText={translateString("cancel")}
                    onDialogClose={() => setPendingUserChanges(null)}
                    onOkClick={() => handleDialogConfirm()}
                />
            )}
        </>
    );
}

export default ContractGroupCompaniesAccessField;
